<template>
    <div v-if="mapProvider == '百度地图'  ">
      <vc-layer-imagery  >
        <vc-imagery-provider-baidu
          ref="providerBaidu"
          :mapStyle="mapStyle"
          :projection-transforms="{ form: 'BD09', to: 'WGS84' }"
        ></vc-imagery-provider-baidu>
      
      </vc-layer-imagery>
    </div>
</template>

<script>
import {toRaw} from 'vue'
  export default {
    name:"ProviderBaidu",
    props:['defaultProvider'],
    data(){
      return {
        mapStyle:'',
        mapProvider:'',
        mapOptions:[
            {
            value: 'normal',
            label: '默认样式'
            },
            {
            value: 'vec',
            label: '百度电子'
            },
            {
            value: 'img',
            label: '百度影像' // 不支持https
            },
            {
            value: 'dark',
            label: '黑夜风格'
            }, 
            {
            value: 'midnight',
            label: '午夜蓝'
            },
            {
            value: 'traffic',
            label: '百度路况'
            }
        ],
      }
    },
    methods:{
      getMapStyle(mapStyle){
        this.mapStyle = mapStyle;
      },
      getMapArray(currentMap){
        if(currentMap !== "百度地图" && this.$refs.providerBaidu){
          this.$refs.providerBaidu.unload();
        }else if(currentMap == "百度地图"){
            console.log("百度Options:",this.mapOptions)
            this.mapProvider = currentMap ;
            this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
            // this.mapStyle = this.mapOptions[0].value ;
        }
      },
    },
    mounted(){
      if(this.defaultProvider){
        console.log("百度Options:",this.mapOptions)
        this.mapStyle = this.mapOptions[0].value ;
        this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
      }
      this.$bus.on('getMapStyle',this.getMapStyle);
      this.$bus.on('getMapArray',this.getMapArray);
      this.$bus.on("getCurrentMap",this.getMapArray);
    },
    beforeUnmount() {
        this.$bus.all.clear();
    },
  }
</script>

<style>

</style>